import { useEffect, useState } from "react";

const navLinks = [
  { id: "live", label: "直播围观" },
  { id: "hot", label: "今日热榜" },
  { id: "danmaku", label: "弹幕现场" },
  { id: "connect", label: "连麦吃瓜" },
  { id: "column", label: "话题分类" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("live");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const sections = navLinks.map((n) => n.id);
      let current = "live";
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 120) {
          current = id;
        }
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goAnchor = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 shadow-sm backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2 whitespace-nowrap"
        >
          <span className={`w-9 h-9 rounded-2xl flex items-center justify-center text-lg ${scrolled ? "bg-primary-500 text-background-50" : "bg-primary-500/90 text-background-50"}`}>🍉</span>
          <span
            className={`font-heading text-xl tracking-wide ${
              scrolled ? "text-foreground-900" : "text-background-50"
            }`}
          >
            吃瓜频道
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              onClick={(e) => {
                e.preventDefault();
                goAnchor(n.id);
              }}
              className={`px-4 py-2 rounded-full text-sm transition-colors whitespace-nowrap ${
                active === n.id
                  ? "bg-primary-500 text-background-50"
                  : scrolled
                    ? "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                    : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
              }`}
            >
              {n.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#live"
            onClick={(e) => {
              e.preventDefault();
              goAnchor("live");
            }}
            className={`text-sm whitespace-nowrap cursor-pointer transition-colors ${
              scrolled ? "text-foreground-700 hover:text-primary-600" : "text-background-100 hover:text-background-50"
            }`}
          >
            登录
          </a>
          <a
            href="#live"
            onClick={(e) => {
              e.preventDefault();
              goAnchor("live");
            }}
            className="bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2.5 rounded-full whitespace-nowrap inline-flex items-center gap-2 transition-colors cursor-pointer"
          >
            <i className="ri-live-line text-base"></i>
            进入直播间
          </a>
        </div>

        <button
          aria-label="打开菜单"
          onClick={() => setOpen(!open)}
          className={`lg:hidden w-10 h-10 rounded-xl flex items-center justify-center text-xl cursor-pointer ${
            scrolled ? "text-foreground-900 bg-background-100" : "text-background-50 bg-background-50/15"
          }`}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 flex flex-col gap-1">
          {navLinks.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              onClick={(e) => {
                e.preventDefault();
                goAnchor(n.id);
              }}
              className="px-3 py-2.5 rounded-xl text-sm text-foreground-800 hover:bg-background-100 hover:text-primary-600 cursor-pointer whitespace-nowrap"
            >
              {n.label}
            </a>
          ))}
          <a
            href="#live"
            onClick={(e) => {
              e.preventDefault();
              goAnchor("live");
            }}
            className="mt-1 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 py-3 rounded-xl inline-flex items-center justify-center gap-2 whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-live-line"></i>
            进入直播间
          </a>
        </div>
      )}
    </header>
  );
}